module.exports = __webpack_public_path__ + "img/linkedinLogoWhite.d506636a.svg";